import React from "react";
import { Col, Row } from "reactstrap";

const BreadCrumb = ({ currentPage, title, pageTitle, icon }: any) => {
  return (
    <React.Fragment>
      <Row className={title && "mb-lg-5"}>
        <Col xs={12}>
          <div className="left-area">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#">{pageTitle}</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  {currentPage}
                </li>
              </ol>
            </nav>
            {title ? (
              <h1 className="mb-4">
                {icon || null}
                <span className="text">{title}</span>
              </h1>
            ) : null}
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default BreadCrumb;
